import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { Pack } from "../../packs.types";
import { requestUpdatePack } from "./updatePack.request";

const useUpdatePack = (
  options?: MutationOptions<Pack, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdatePack,
    ...options
  });
};

export default useUpdatePack;
